import { cn } from "../../lib/cn";

interface FavoriteStarProps {
  favorited: boolean;
  disabled?: boolean;
  onToggle: () => void;
  // Stop the click from bubbling to an enclosing click target (e.g. the
  // row-click NoteEntry card, which would otherwise also open the side panel).
  stopPropagation?: boolean;
  className?: string;
}

// The WickScope ".wsj-star" toggle: a hollow star in the muted stroke that fills
// gold when on. Accessible as a pressed toggle button so the existing
// "favorite note" test contract keeps matching.
export function FavoriteStar({
  favorited,
  disabled = false,
  onToggle,
  stopPropagation = false,
  className,
}: FavoriteStarProps) {
  return (
    <button
      type="button"
      aria-label={favorited ? "Unfavorite note" : "Favorite note"}
      aria-pressed={favorited}
      disabled={disabled}
      onClick={(event) => {
        if (stopPropagation) event.stopPropagation();
        onToggle();
      }}
      className={cn(
        "grid place-items-center rounded-control p-1 transition-colors",
        favorited ? "text-warn" : "text-outline hover:text-on-surface-variant",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="h-[14px] w-[14px]"
        fill={favorited ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
      >
        <path d="M12 3.5l2.6 5.27 5.82.85-4.21 4.1.99 5.8L12 16.77l-5.2 2.74.99-5.8-4.21-4.1 5.82-.85z" />
      </svg>
    </button>
  );
}
